<template>
  <div class="">
    <Header></Header>
    <div class="contain" style="margin-top: 20px;">
    <el-card class="box-card">
          <div slot="header" class="clearfix">
            <el-breadcrumb separator="/" v-if="nav">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ name: 'AppResourceAdd', query: {nav_id: nav.id} }">{{nav.name}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
    <div class="form_btm">
      <el-form ref="form" :model="form" label-width="80px" :rules="rules">
        <el-form-item label="文件名称" prop="title">
          <el-input v-model="form.title" ></el-input>
        </el-form-item>
        <el-form-item label="文件说明" prop="desc">
          <el-input type="textarea" v-model="form.desc" ></el-input>
        </el-form-item>
        <el-form-item label="文件类型" prop="type_id">
          <el-select v-model="form.type_id"  placeholder="请选择您要上传的文件类型">
            <el-option v-for="item of TypeList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属学段" prop="class_id">
          <el-radio-group v-model="form.class_id" @input="selectNianji">
            <el-radio v-for="item of GradeList" :label="item.id">{{item.name}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="所属科目" prop="subject_id">
          <el-select v-model="form.subject_id" placeholder="请选择上传文件所属的科目">
            <el-option v-for="item of CourseList" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="上传文件">
          <div v-if="form.attachment_id >0">
            <div >
            <el-avatar shape="square" :size="50" :src="attachment.thumbs" ></el-avatar>
            <span class="title">{{ attachment.title }}</span>
            </div>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="onSubmit('form')">提交</el-button>
          <el-button>取消</el-button>
        </el-form-item>
      </el-form>
    
     
    </div>
  </el-card>
</div>
    <Footer></Footer>
  </div>
  
</template>
<script>
import { getCache } from '@/utils/cache'
import { getListOptions } from '@/utils/app'
import Preview from '@/components/preview'
import Header from '@/components/header'
import Footer from '@/components/footer' 
import { resInfo, resAdd } from '@/api/'

export default {
  data() {
    return {
      dialogTableVisible: false,
      outerVisible: false,
      gridData: [],
      attachment: {},
      CourseList: [],
      GradeList: [],
      TypeList: [],
      total: 0,
      form: {
        title: '',
        desc: '',
        type_id: '',
        class_id: '',
        subject_id: '',
        attachment_id: 0,
        id: 0,
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur'}
        ],
        desc: [
          { required: true, message: '请输入描述', trigger: 'blur' }
        ],
        type_id: [
          { required: true, message: '请选择类型', trigger: 'change' }
        ],
        class_id: [
          { required: true, message: '请选择班级', trigger: 'change' }
        ],
        subject_id: [
          { required: true, message: '请选择科目', trigger: 'change' }
        ]
      },
      nav: {
        id: '100',
        name: '编辑资源'
      }
    }
  },
  watch: {
  },
  components: {
    Preview, Header, Footer
  },
  computed: {},
  mounted() {
  },
  created() {
    resInfo({id: this.$route.params.id}).then(res=> {
      this.form = {
        title: res.title,
        desc: res.desc,
        type_id: res.type_id,
        class_id: res.class_id,
        subject_id: res.subject_id,
        attachment_id: res.attachment_id,
        id: res.id,
      }
      this.attachment = res.attachment
    })
    this.getConfig()
  },
  methods: {
    onSubmit(formName) {
      if(!this.form.attachment_id) {
        this.$message.error('请先上传文件')
        return
      }
      this.$refs[formName].validate((valid) => {
          if (valid) {
            resAdd(this.form).then(res=> {
              this.$message({
                message: res,
                type: 'success',
                onClose: res => {
                  this.$router.back()
                }
              })
            })
          } else {
            console.log('error submit!!')
            return false
          }
      });
      console.log('submit!');
    },
    getConfig() {
      let configs = getCache('configs')
      this.GradeList = configs[0]['children']
      this.CourseList = configs[1]['children']
      this.TypeList = configs[2]['children']
    },
    selectNianji(e){
      let arr
      for(let i in this.GradeList) {
        if(this.GradeList[i]['id'] == e) {
          arr = this.GradeList[i]
          break
        }
      }
      let configs = getCache('configs')
      this.CourseList = getListOptions(arr.name, configs[1]['children'])  
    }
  }
}

</script>



<style scoped>
.uploader-example {
    width: 880px;
    padding: 15px;
    margin: 40px auto 0;
    font-size: 12px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .4);
  }
  .uploader-example .uploader-btn {
    margin-right: 4px;
  }
  .uploader-example .uploader-list {
    max-height: 440px;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
    .form_page{ background:#ededed; padding: 0 0 110px;}
    .form_page .person_top{ width:100%; height:184px; background:url(../assets/person_ban.jpg) center top no-repeat; padding:50px 0 0; position: relative; z-index:0px;}
    .form_page .person_top .top_lf{ width:800px; margin:0 0 0 140px;}
    .form_page .person_top .top_lf .txt1 img{ height:20px; position: relative; top:2px; margin-right:8px;}
    .form_page .person_top .top_lf .txt1 span{ margin-right:16px; font-size:20px;}
    .form_page .person_top .top_lf .txt1 .name{ color:#79ffce;}
    .form_page .person_top .top_lf .txt1 .post{ color:#fff;}
    .form_page .person_top .top_lf .tx{ margin-top:15px; float: left;}
    .form_page .person_top .top_lf .tx img{ width:109px; height:109px; display:block; border-radius:10px;}
    .form_page .person_top .top_lf .txt2{ float: left; color:#fff; font-size:18px; margin:15px 0 0 25px;}
    .form_page .person_top .top_lf .txt2 .zp .num{ color:#e28f36; margin-right:10px;}
    .form_page .person_top .top_lf .txt2 .js{ margin:15px 0 0; font-size:14px;}
    .form_page .person_top .top_rt{ position: absolute; left:50%; bottom:25px; z-index:10; margin-left:400px; text-align:center;}
    .form_page .person_top .top_rt img{ display:block; margin:0 auto; height:32px;}
    .form_page .person_top .top_rt .tit{ color:#fff; font-size:16px; margin:3px 0 0;}

    .form_page .form_btm{ margin:55px auto 0; background:#fff; padding:60px 300px 60px;}
</style>
<style>
    .form_page .el-textarea__inner{ height:120px;}
    .form_page .el-select{ width:100%;}
</style>